module.exports = __webpack_public_path__ + "img/T1D_xh16.6c49d062.png";